import type { GpcLocale } from '../types/gpc-categories.types';

/**
 * Table name and fallback option sets for the GPC Categories listing.
 *
 * The option lists below are **fallbacks only**. Filter values come from
 * `POST /tables/columns` (see `useConfigTableFacets`), which reports the whole
 * table's distinct values per column. These lists keep the closed-vocabulary filters
 * usable when that call fails, and are otherwise unused.
 *
 * `gpc_path` has no fallback list: 5,595 distinct values per locale is past the
 * endpoint's 500-value facet cap, so it always degrades to a free-text input.
 */

/** The registered table these filters query — the `table_name` body field of both
 *  `/tables/*` endpoints and the `tableName` of the export, and a registry lookup
 *  key on both services. */
export const GPC_CATEGORIES_TABLE = 'gpc_categories';

/** Fallback `locale` — the two values the CHECK constraint allows. The live facet
 *  comes from the enum rather than a `SELECT DISTINCT`, so a locale with no rows
 *  would still appear in the dropdown. */
export const GPC_LOCALE_OPTIONS: GpcLocale[] = ['en-US', 'en-GB'];

/** Fallback `depth` — the published tree bottoms out at 7 segments in both locales
 *  (`MAX_DEPTH` in `agentic-config/app/models/db/gpc_category.py`). Served live by
 *  `SELECT DISTINCT` rather than a hardcoded enum, because the tree's depth is
 *  Google's to change. */
export const GPC_DEPTH_OPTIONS = ['1', '2', '3', '4', '5', '6', '7'];
